var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDismissWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 25.6663C20.443 25.6663 25.6663 20.443 25.6663 13.9997C25.6663 7.55635 20.443 2.33301 13.9997 2.33301C7.55635 2.33301 2.33301 7.55635 2.33301 13.9997C2.33301 20.443 7.55635 25.6663 13.9997 25.6663Z",
    fill: "#C6B2B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1597 9.83977C10.7952 9.47528 10.2043 9.47528 9.83977 9.83977C9.47528 10.2043 9.47528 10.7952 9.83977 11.1597L12.6798 13.9997L9.83977 16.8398C9.47528 17.2043 9.47528 17.7952 9.83977 18.1597C10.2043 18.5242 10.7952 18.5242 11.1597 18.1597L13.9997 15.3197L16.8398 18.1597C17.2043 18.5242 17.7952 18.5242 18.1597 18.1597C18.5242 17.7952 18.5242 17.2043 18.1597 16.8398L15.3197 13.9997L18.1597 11.1597C18.5242 10.7952 18.5242 10.2043 18.1597 9.83977C17.7952 9.47528 17.2043 9.47528 16.8398 9.83977L13.9997 12.6798L11.1597 9.83977Z",
    fill: "#81545D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDismissWhite);
export default __webpack_public_path__ + "static/media/dismiss-white.59ef794ea647736f4c1eb404c98d1008.svg";
export { ForwardRef as ReactComponent };